/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button, Row, Col, message, Modal } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, AdvanceForm } from 'Components';
import { sKeylist } from '../../service/dictionary/dataitem';
import { list, exportFun } from '../../service/inventory/entry';
import { orgList } from '../../service/org';
import { categoryTree } from '../../service/category';
import {Store, Actions} from './store';
import { objectSerial } from 'Utils';

class GoDownEntry extends Reflux.Component {
  constructor (props) {
    super(props);
    const d = new Date();
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.defaultIndex = '';
    this.defaultOrgId = null;
    this.defaultOrgType = null;
    this.defaultDate = d.format('yyyy-MM-dd');
    this.state = {
      entry_type: [],
      orgList: [],
      categoryTree: [],
      rows: [],
      total: 3,
      orgIdIndex: '',//默认是品牌商，而且只有一个
      searchObj: {
        orgId: null,
        orgType: null,
        type: "",
        productName: "",
        categoryId: "",
        storageName: "",
        startDate: d.format('yyyy-MM-dd'),
        endDate: d.format('yyyy-MM-dd'),
        s: 10,
        p: 1,
      },
    };
    this.addStyle = {position:'absolute', bottom: '12px', right:'112px'};
    this.exportStyle = {position:'absolute', bottom: '12px', right:'12px'};
    this.pageChange = this.pageChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'product'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange({useEntryStore: true, entryIndex: this.state.orgIdIndex});
      Actions.paramChange('entryParams', {...this.state.searchObj});
    }else if(path[1] === 'goDownEntry' && path[2] !== 'add') {
      Actions.useStoreChange({useEntryStore: true, entryIndex: this.state.orgIdIndex});
      Actions.paramChange('entryParams', {...this.state.searchObj, p:1});
    }else{
      Actions.useStoreChange({useEntryStore: false});
    }
  }
  componentWillMount () { //准备数据
    const self = this;
    const data = this.store.state;
    if (data.useEntryStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        orgIdIndex: data.entryIndex,
        searchObj: {
          ...this.state.searchObj,
          ...data.entryParams,
        }
      });
    }
    sKeylist({ sKey: 'entry_type' }).then(res => { //门店运营方式
      if (res.data && res.data.length > 0) {
        let arr = [{ value: '', text: '全部' }];
        res.data.forEach(x => {
          if(x.sKey == 1 || x.sKey == 8){
            arr.push({ value: x.sKey, text: x.name });
          }
        })
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ entry_type: arr })
          }
        }, 200);
      }
    });
    categoryTree().then(res => {
      if(res.status){
        let timer = window.setInterval(function() {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({categoryTree: res.data});
          }
        })
      }
    });
    orgList().then(res => { //所属经销商
      if(res.data && res.data.length>0){
        const data = res.data.filter(x => x.type === 1).map((x, index) => {
          return {
            ...x,
            value: index+'',
            text: x.name
          }
        });
        let orgIdIndex = data.findIndex(x => x.type === 1);
        orgIdIndex = orgIdIndex === -1 ? null : orgIdIndex;
        self.defaultIndex = orgIdIndex;
        self.defaultOrgId = orgIdIndex !== null ? data[orgIdIndex]['id'] : null;
        self.defaultOrgType =  orgIdIndex !== null ? data[orgIdIndex]['type'] : null;
        if(self.state.orgIdIndex !== '' && self.state.orgIdIndex !== null){
          orgIdIndex = self.state.orgIdIndex;
        }

        let timer = window.setInterval(function(){
          if(self.mounted){
            window.clearInterval(timer);

            if(orgIdIndex !== null){
              self.setState({
                ...self.state,
                orgList: data,
                orgIdIndex,
                searchObj: {
                  ...self.state.searchObj,
                  orgId: data[orgIdIndex]['id'],
                  orgType: data[orgIdIndex]['type'],
                }
              });
            }else{
              self.setState({
                ...self.state,
                orgList: data,
                orgIdIndex
              });
            }
          }
        }, 0);
      }
    });
  }
  componentDidMount () {
    this.mounted = true;
    if(this.store.state.useEntryStore) {
      this.getData();
    }
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  goView (url) {
    hashHistory.push(url);
  }

  getData(){
    const self = this;
    const {searchObj} = this.state;
    list({...searchObj, endDate: searchObj.endDate+' 23:59:59'}).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data.map((x, index) => {
          return {
            ...x,
            index
          }
        })});
      }else{
        console.error(res.message);
      }
    });
  }

  advanceReset () {
    const self = this;
    this.setState({
      orgIdIndex: this.defaultIndex,
      searchObj: {
        ...this.state.searchObj,
        orgId: this.defaultOrgId,
        orgType: this.defaultOrgType,
        type: "",
        productName: "",
        categoryId: "",
        storageName: "",
        startDate: this.defaultDate,
        endDate: this.defaultDate,
        //s: 10,
        p: 1,
      }
    }, function () {
      self.getData();
    })
  };

  advanceSubmit (form) {
    const {orgId, startDate, endDate} = this.state.searchObj;
    if (!(orgId && startDate && endDate)) {
      message.error('所属组织和操作时间必须设置');
      return null;
    }

    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, p: 1 } }, function(){
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'lastOptTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          startDate: value.from,
          endDate: value.end
        }
      })
    }else if(name === 'orgIdIndex'){
      //let index = parseInt(value, 10);//orgList
      //let data = index ? this.state.orgList[index] : {orgId: null, orgType: null};
      let data = this.state.orgList[value] || { orgId: null, orgType: null };
      this.setState({ orgIdIndex: value, searchObj: { ...this.state.searchObj, orgId: data.id, orgType:data.type } })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }
  export(){
    const {searchObj, rows, total} = this.state;
    if(!rows.length && !total){
      message.warning('当前没有数据可以导出。请查询后再做操作。');
    } else {
      Modal.confirm({
        title: '操作提示',
        content: '确定按当前查询条件导出数据吗?',
        onOk() {
          window.location.href = `${exportFun}?${objectSerial({...searchObj, s: total, endDate: searchObj.endDate+' 23:59:59'})}&exPortType=0&exPortIds=`
        },
        onCancel() {
        },
      });
    }
  }

  render () {
    const { rows, total, searchObj, entry_type, orgList, orgIdIndex, categoryTree } = this.state;
    const advanceProps = {
      fileds: [
        {
          name: 'orgIdIndex',
          label: <span><sup style={{color: '#d61518'}}>*</sup>所属组织</span>,
          text: '输入所属组织',
          type: 'select',
          defaultValue: orgIdIndex+'',
          //dataType: 'number',
          options: orgList,
        },
        {
          name: 'type',
          label: '类型',
          text: '选择类型',
          dataType: 'number',
          defaultValue: searchObj.type+'',
          options: entry_type,
          multiple: false,//支持多选
          type: 'select'
        },
        {
          name: 'storageName',
          label: '仓库',
          text: '输入仓库',
          defaultValue: searchObj.storageName,
          type: 'default'
        },
        {
          name: 'categoryId',
          label: '产品类别',
          text: '选择产品类别',
          type: 'treeSelect',
          dataType: 'number',
          defaultValue: searchObj.categoryId+'',
          options: categoryTree,
          dropdownStyle:{height:'240px',overflow:'auto'}
        },
        {
          name: 'productName',
          label: '产品',
          text: '输入产品',
          defaultValue: searchObj.productName,
          type: 'default'
        },
        {
          name: 'lastOptTime',
          label: <span><sup style={{color: '#d61518'}}>*</sup>操作时间</span>,
          options: [
            {text: '开始时间'},
            {text: '结束时间'}
          ],
          type: 'dateComp',
          defaultValue: {
            from: searchObj.startDate || '',
            end: searchObj.endDate || ''
          },
          //dataType: 'date'
        }
      ],
      handle: this.advanceSubmit,
      reset: this.advanceReset,
      fieldHandle: this.setFilterParam
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'index',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '操作时间',
          dataIndex: 'createdDate',
          render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
        },{
          title: '出入库类型',
          dataIndex: 'type',
          render: (text, record, index) => {
            let arr =  entry_type.filter( x => x.value == text );
            if(arr.length){
              return arr[0]['text']
            }else{
              return '----'
            }
          }
        },
        {
          title: '产品编码',
          dataIndex: 'productCode',
          render: (text, record, index) => {
            //return <a href={`#/product/${record.productId}`}>{text}</a>
            return text
          }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          render: (text, record, index) => {
            //return <a href={`#/product/${record.productId}`}>{text}</a>
            return text
          }
        }, {
          title: '规格',
          dataIndex: 'specName'
        }, {
          title: '产品类别',
          dataIndex: 'categoryText'
        }, {
          title: '单位',
          dataIndex: 'unitText'
        }, {
          title: '仓库',
          dataIndex: 'storageName'
        }, {
          title: '货位',
          dataIndex: 'localCode'
        }, {
          title: '数量',
          dataIndex: 'storageNum'
        }, {
          title: '备注',
          dataIndex: 'remark',
          render: (text, record, index) => {
            return text||'';
          }
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['入库单']} defaultKey={0} />
      <Row className="dms-table-box" gutter={0}>
        <Col className="gutter-row" span={8}>
          <AdvanceForm {...advanceProps}/>
        </Col>
        <Button icon="plus" style={this.addStyle} onClick={this.goView.bind(this, `/goDownEntry/add/0`)}>新建</Button>
        <Button onClick={this.export.bind(this)} icon="export" style={this.exportStyle}>导出</Button>
      </Row>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
export default withRouter(GoDownEntry);



// WEBPACK FOOTER //
// ./src/routes/inventory/godownEntry.js